/* eslint-disable react/no-multi-comp */
import React from 'react';
import { matchPath } from 'react-router-dom';
import _ from 'underscore';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { List, Typography } from '@mui/material';

import useRouter from 'utils/useRouter';
import { NavigationListItem } from './components';

const useStyles = makeStyles((theme) => ({
	root: {
		marginBottom: theme.spacing(3),
	},
}));

const reduceChildRoutes = (props) => {
	const { router, items, page, depth, userRole, userProjects } = props;
	if ((!page.roles || page.roles.includes(userRole)) && (!page.projects || _.intersection(page.projects, userProjects).length !== 0)) {
		if (page.children) {
			const open = matchPath(router.location.pathname, {
				path: page.href,
				exact: false,
			});

			items.push(
				<NavigationListItem
					depth={depth}
					icon={page.icon}
					 key={page.href || String(page.title)}
					label={page.label}
					open={Boolean(open)}
					title={page.title}
					target={page.target}
				>
					<NavigationList
						depth={depth + 1}
						pages={page.children}
						router={router}
						userRole={userRole}
						userProjects={userProjects}
					/>
				</NavigationListItem>
			);
		} else {
			items.push(
				<NavigationListItem
					depth={depth}
					href={page.href}
					icon={page.icon}
					key={page.href || String(page.title)}
					label={page.label}
					title={page.title}
					target={page.target}
				/>
			);
		}
	}

	return items;
};

const NavigationList = (props) => {
	const { pages, ...rest } = props;

	return (
		<List>
			{pages.reduce(
				(items, page) => reduceChildRoutes({ items, page, ...rest }),
				[]
			)}
		</List>
	);
};

NavigationList.propTypes = {
	depth: PropTypes.number,
	pages: PropTypes.array,
};

const Navigation = (props) => {
	const { title, pages, className, component: Component, userRole, userProjects, ...rest } = props;

	const classes = useStyles();
	const router = useRouter();

	return (
		<Component {...rest} className={clsx(classes.root, className)}>
			{title && <Typography variant="overline">{title}</Typography>}
			<NavigationList depth={0} pages={pages} router={router} userRole={userRole} userProjects={userProjects} />
		</Component>
	);
};

Navigation.propTypes = {
	className: PropTypes.string,
	component: PropTypes.any,
	pages: PropTypes.array.isRequired,
	title: PropTypes.string,
	userRole: PropTypes.string,
	userProjects: PropTypes.string
};

Navigation.defaultProps = {
	component: 'nav',
};

export default Navigation;
